module.exports = __webpack_public_path__ + "static/media/18-光固化机（蓝）旧版.37f8046e.jpg";